import { Injectable } from '@angular/core';
import { Observable, of, from } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

interface VersionInfo {
  version: string;
}

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  
  constructor() { }

  getDropNumber(): Observable<string> {
    // Use fetch API to bypass HTTP interceptors which add authentication headers
    return from(
      fetch('/eQMS-assets/version.json')
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data: VersionInfo) => {
          return data.version;
        })
        .catch(() => {
          return 'Unknown';
        })
    );
  }
}
